import TrackingService from "@services/tracking/tracking.service";

import { TypedAnalyticsEvent } from "../types/analyticsEvent";
import {
    SectionImpressionAemModel,
    SectionImpressionTrackingInfo,
} from "../types/trackingInfo/sectionImpressionTrackingInfo";
import { getPageInfo, getUserInfo } from "./pageImpressionTracker";
import { getEventName, getJsonPayload } from "./utils";

const trackSectionImpression = (element: HTMLElement): void => {
    const aemModel: SectionImpressionAemModel = getJsonPayload(element);

    const event: TypedAnalyticsEvent<SectionImpressionTrackingInfo> = {
        event: getEventName(element),
        payload: {
            eventData: {
                ...aemModel,
                category: "", // TODO: missing from aem json
                type: "", // TODO: missing from aem json
                placement: "", // TODO: missing from aem json
                target: "", // TODO: missing and unsure what this is
            },
            pageInfo: getPageInfo(),
            userInfo: getUserInfo(),
        },
    };

    TrackingService.track(event);
};

export { trackSectionImpression };
